module.exports = __webpack_public_path__ + "img/jempolan.803b86ec.png";